// Canonical design tokens for the partner portal.
//
// This is the single source of truth for colors and typography. The SCSS
// mirror in ./_tokens.scss must be kept in sync (same names, same values) so
// <style> blocks and JS read from the same palette.
//
// Decoupled on purpose: nothing here imports app code, so the whole folder can
// be lifted into a shared library later without untangling dependencies.

export const colors = {
  wine: '#29061B',
  wineMid: '#4A1A35',
  wineLight: '#F6EDF3',
  lavender: '#CCC9E6',
  lavenderLight: '#EEEDFA',
  pink: '#FDD2DC',
  pinkLight: '#FFF0F3',
  paper: '#FDE4D6',
  paperLight: '#FFF7F2',
  orange: '#FF5F3F',
  orangeLight: '#FFF0EC',
  white: '#FFFFFF',
  bg: '#FDFBF9',
  border: '#EDE7E3',
  borderLight: '#F5F0ED',
  text: '#29061B',
  textSec: '#7A6874',
  textTer: '#B5A5AE',
  success: '#2D8A56',
  successLight: '#EBF7F0',
  danger: '#D14343',
  // Darker red for danger text; $c-danger fails WCAG AA on the light/bg surfaces.
  dangerText: '#BC3C3C',
  dangerLight: '#FCEAEA',
  navy: '#2E3A59',
  blue: '#4A6FA5',
  blueLight: '#EAF0F8',
}

export const fonts = {
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
}
